function getGlobalLsConfig() {
	const config = typeof globalLsConfig === 'undefined' ? {} : globalLsConfig;
	return config;
}

module.exports = {
	getGlobalLsConfig,
};
